import {
	ChangeDetectorRef,
	Component,
Inject,	// EventEmitter,
	// Output,
} from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import {Router, ActivatedRoute, ParamMap} from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

import {HttpClient} from "@angular/common/http";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {FormControl} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Subject} from "rxjs";
import {DatePipe} from "@angular/common";
import {TaeglicheAnlieferungsmenge} from "./taeglicheanlieferungsmenge.model";
import {Kernantwort} from "../../shared/response/kernantwort.model";
import {ErrorHelper} from "../../shared/error.helper";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";

const PATH_FILE = 'app/protected/taeglicheanlieferungsmenge/taeglicheanlieferungsmenge.component.ts';
const OBJ_LNG_NAME = 'taeglicheanlieferungsmenge';
const BACKEND_PATH_PREFIX = 'tmm';
// const REST_API_BASE =
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
// 	( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
// 	oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
// 	REST_API_BASE +
// 	BACKEND_PATH_PREFIX; // z.B. tipp/

@Component({
    selector: 'oase-taeglicheanlieferungsmenge',
    templateUrl: './taeglicheanlieferungsmenge.component.html',
    styleUrls: ['./taeglicheanlieferungsmenge.component.css'],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule]

})
export class TaeglicheAnlieferungsmengeComponent extends Tabelle<TaeglicheAnlieferungsmenge> {

	logprotokolls: TaeglicheAnlieferungsmenge[] = new Array<TaeglicheAnlieferungsmenge>();
	// neu: Lieferant = null;
	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredTaeglicheAnlieferungsmengeen: ReplaySubject<TaeglicheAnlieferungsmenge[]> = new ReplaySubject<TaeglicheAnlieferungsmenge[]>(1);
	public datum = null;

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
	@Inject(L10N_LOCALE) public locale: L10nLocale,
	@Inject(L10N_CONFIG) private config: L10nConfig,
	public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		// private _data: Data,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public datepipe: DatePipe,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/tmm",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: 'datumSortierbar',
				DEFAULT_SORT_START: 'desc',
				extraDataForAdding: { }
			}
		);
		this.displayedColumns = ['tag', 'datumSortierbar', 'anlieferungsmenge', 'temperatur'];
	}

	getApiParams() {
		this.datum = this.route.snapshot.paramMap.get("datum");
		return "seite/"+ (this.datum == null ? "0" : this.datum);
		// return "seite";
	}


}

// import { oase_config } from '../../../environments/environment';
// import { AuthService } from '../../shared/auth.service';
// import { TaeglicheAnlieferungsmenge} from './taeglicheanlieferungsmenge.model';
// import { Component, Pipe, PipeTransform, Inject, ViewChild } from '@angular/core';
// import { MediaObserver } from '@ngbracket/ngx-layout';
// import { Response, ResponseType } from '@angular/http';
// import { Title } from '@angular/platform-browser';
// import { ActivatedRoute, ParamMap, Router } from '@angular/router';



// import { Md2DataTable } from 'md2';
// // import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
// import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
// import { Observable } from 'rxjs/Rx';
// import { Httpstatus } from '../../shared/response/httpstatus.model';
// import { Kernantwort } from '../../shared/response/kernantwort.model';
// import { SessionService } from '../../shared/session.service';
// import { LoggerService } from '../../shared/logger.service';
//
// const PATH_FILE = 'app/protected/taeglicheanlieferungsmenge/taeglicheanlieferungsmenge.component.ts';
// const OBJ_LNG_NAME = 'taeglicheanlieferungsmenge';
// const BACKEND_PATH_PREFIX = 'tmm/';
// const REST_API_BASE =
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
//   ( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
//   oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
//   REST_API_BASE +
//   BACKEND_PATH_PREFIX; // z.B. kernrecht/
//
// @Pipe({ name: 'dataPipeTaeglicheAnlieferungsmenge' })
// export class DataTablePipeTaeglicheAnlieferungsmenge implements PipeTransform {
//   constructor(private _logger: LoggerService) { }
//   transform(array: TaeglicheAnlieferungsmenge[], query: string): TaeglicheAnlieferungsmenge[] {
//     this._logger.log(PATH_FILE + ' - transform BEGIN');
//     this._logger.log(PATH_FILE + ' - transform array: ', array);
//     this._logger.log(PATH_FILE + ' - transform query: ', query);
//     if (query) {
//       return array.filter((value: TaeglicheAnlieferungsmenge, index: number, arr: TaeglicheAnlieferungsmenge[]) =>
//         value.tag != null && value.tag.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
//         value.datum != null && value.datum.toLowerCase().indexOf(query.toLowerCase()) > -1
//       );
//     }
//     return array;
//   } // transform
// } // class DataTablePipe
//
// @Component({
//   selector: 'oase-taeglicheanlieferungsmenge',
//   templateUrl: './taeglicheanlieferungsmenge.component.html',
//   styleUrls: ['./taeglicheanlieferungsmenge.component.css']
// })
// export class TaeglicheAnlieferungsmengeComponent extends Localization {
//   OBJ_LNG_NAME = OBJ_LNG_NAME; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
//   REST_API_BASE= REST_API_BASE;
//   data: TaeglicheAnlieferungsmenge[] = new Array<TaeglicheAnlieferungsmenge>();
//   search: string = '';
//   ladedaten: boolean = true;
//   dialogrunningajaxcall: boolean = false;
//   fehlerMain: Kernantwort = null;
//   @ViewChild(Md2DataTable) md2datatable: Md2DataTable;
//
//   constructor(
//     private route: ActivatedRoute,
//     private router: Router,
//     private breadcrumbService: BreadcrumbService,
//     public authService: AuthService,
//     private authHttp: AuthHttp,
//     public locale: LocaleService,
//     public translation: TranslationService,
//     public sessService: SessionService,
//     public title: Title,
//     private _logger: LoggerService,
//     public media: MediaObserver) {
//     super(locale, translation);
//
//     route.paramMap.subscribe((params: ParamMap)=>{this.getTaeglicheAnlieferungsmenge(params.get('datum'));});
//     // Set document title.
//     this.title.setTitle(this.getTitle());
//     this.translation.translationChanged.subscribe(() => {
//       this.title.setTitle(this.getTitle());
//     });
//     this.sessService.logSessionInfos(PATH_FILE);
//   }
//
//   getTitle() {
//     return this.translation.translate('taeglicheanlieferungsmenge.title') + ' - ' + this.translation.translate('project.title');
//   }
//
//   private getTaeglicheAnlieferungsmenge(datum: string) {
//
//     if (datum == null || datum === "") datum = "0";
//
//     this._logger.log(PATH_FILE + ' - getTaeglicheAnlieferungsmenge Begin für URL: '+REST_API);
//
//     this.ladedaten = true;
//
//     this.http
//       .get(this.REST_API + 'liste/'+datum)
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         this.ladedaten = false;
//         this.data = data.json() as TaeglicheAnlieferungsmenge[];
//         this._logger.log(PATH_FILE + ' - getTaeglicheAnlieferungsmenge End');
//         // Initial-Sortierung da dies über Attribute im HTML nicht korrekt funktioniert
//         if(this.md2datatable != null && (this.md2datatable.getSort() == null || this.md2datatable.getSort().sortBy == null || !this.md2datatable.getSort().sortBy))
//           this.md2datatable.setSort('datumSortierbar', 'desc');
//       },
//       err => {
//         this.ladedaten = false;
//         ErrorHelper.handleError(err,"Fehler beim holen der TaeglicheAnlieferungsmenge",this._logger, this.translation)
//       },
//       () => {
//         this.ladedaten = false;
//         this._logger.log(PATH_FILE + ' - Holen der TaeglicheAnlieferungsmenge abgeschlossen')
//       }
//       );
//   }
//
//   public handleError (error: Response | any, prefix: string = "handleError") {
//     this._logger.log(PATH_FILE + ' - handleError - ' + prefix + ': ', error);
//
//     this.dialogrunningajaxcall = false;
//
//     let fehler = new Kernantwort();
//     if (error instanceof Response) {
//       try {
//         fehler = error.json();
//         if(error.status==0 && !error.ok && error.type==ResponseType.Error && error.statusText.length==0) {
//           fehler.httpstatus = new Httpstatus();
//           fehler.httpstatus.name = 'vermutlich 503er Service Temporarily Unavailable';
//           fehler.httpstatus.number = 500;
//         }
//       } catch (e) {
// //        this.fehler.message = error.toString();
//         fehler.messagehtml = this.translation.translate('allgemein.fehler');
// //        this.fehler.messagehtml = error.text();
//         this._logger.error(PATH_FILE + ' - ERROR ' + error.status + ': ' + prefix + ' (' + error.statusText + ' (' + error.status + ')' + '): ', error.text());
//       }
//     } else {
//       fehler = new Kernantwort();
//       fehler.message = error.message ? error.message : error.toString();
//     }
//
//     if(!fehler.messagehtml)
//       fehler.messagehtml = fehler.message;
//
//     if(fehler && fehler.httpstatus && fehler.httpstatus.number == 500) {
//       this._logger.error(PATH_FILE + ' - ' + prefix + ':' + fehler.messagehtml);
//       fehler.messagehtml = this.translation.translate('allgemein.fehler');
//       this._logger.error(PATH_FILE + ' - ERROR 500: ' + prefix + ' (' + fehler.httpstatus.name + ' (' + fehler.httpstatus.number + ')' + '): ', fehler);
//     } else {
//       this._logger.info(PATH_FILE + ' - ' + prefix + ': ', fehler);
//     }
//     // Nach dem der Fehler fertig erstellt wurde die entsprechende Fehler variable setzten
//     this.setzeFehler(fehler);
//     // Das token mit dem vom Server neu gelieferten erneuern:
//     this.authService.storeNewToken(error);
//     return Observable.throw(fehler.message);
//   }
//
//   setzeFehler(fehler: Kernantwort) {
//       this.fehlerMain = fehler;
//   }
//
//   getDateiUrl(url: string): string{
//     return this.authService.getAuthUrl(REST_API_BASE+url);
//   }
// }
